import { cn, Modal, PrimaryButton, Icon, Text, Badge } from '@artprov/design-system'

export default function ModalMotivoRechazo({ openModal, onCloseModal, motivoRechazo }) {
  return (
    <Modal.Container
      open={openModal}
      className={cn('overflow-x-hidden')}
      onClose={onCloseModal}
      closeOnClickOutside={false}
    >
      <Modal.Content height="auto" width="auto" className={cn('overflow-x-hidden')}>
        <Modal.Header>
          <Modal.Title className="">Declaración rechazada</Modal.Title>
          <Modal.Close onClose={() => onCloseModal(false)} />
        </Modal.Header>
        <Text variant="body2" className="text-tertiary-20 -mt-3">
          Detalles del rechazo para el período {motivoRechazo?.periodo?.replace(/^(\d{4})(\d{2})$/, '$1-$2')}
        </Text>
        <Modal.Body className={cn('overflow-x-hidden mb-0')}>
          <div
            className={cn(
              'w-full px-4 py-4 flex items-center border-l-[4px] rounded',
              'bg-error-50 border-error-10 text-error-10',
              'shadow-[0px_8px_4px_0px_rgba(0,0,0,0.05),_0px_0px_8px_0px_rgba(0,0,0,0.25)]'
            )}
          >
            <div className="flex-1 justify-start">
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>{motivoRechazo?.motivo_rechazo}</li>
                {/* <li>La masa salarial declarada no coincide con la suma de salarios individuales</li> */}
              </ul>
            </div>
          </div>
          <div className="border-t mt-6 mb-4 mt-0 mb-0"></div>

          <p className="font-semibold text-blue-900">
            Fecha de rechazo: <span className="font-normal"> {motivoRechazo?.fecha_rechazo}</span>
          </p>

          <p className="text-gray-500 text-sm mt-1">
            Para mayor información, podés contactarte a emision@provart.com.ar
          </p>
        </Modal.Body>
      </Modal.Content>
    </Modal.Container>
  )
}
